var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-domain-index"},[_c('DomainHeader'),_vm._v(" "),_c('DomainDomainSearch',{on:{"query":_vm.queryDomain}}),_vm._v(" "),_c('DomainContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/new-domain-index.vue